export const PAID = { value: 'paid-licenses', displayName: 'Paid Licenses' };
export const FREE = { value: 'free-licenses', displayName: 'Free Licenses' };
export const DEACTIVATED = { value: 'deactivated-licenses', displayName: 'Deactivated Licenses' };
